var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { isArray } from 'lodash';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { Model } from '@/models/Model';
import { isEqual } from 'lodash';
let AsyncSelect = class AsyncSelect extends Vue {
    constructor() {
        super(...arguments);
        this.items = [];
        this.isLoading = false;
        this.search = '';
        this.selected = [];
    }
    mounted() {
        // if(this.defaultValue) {
        //   this.items = [this.defaultValue];
        //   this.selected = [this.defaultValue];
        // }
    }
    searchChanged(search, oldSearch) {
        if (typeof search !== 'string' || search.length < this.minimumQueryLength) {
            return;
        }
        this.$debounce('querySelections', search);
    }
    querySelections(value) {
        this.isLoading = true;
        const filters = { ...{ search: value }, ...this.filters };
        this.model
            .filter(filters)
            .all()
            .then((models) => {
            const data = [];
            if (this.parseData) {
                models.forEach((model) => {
                    data.push({
                        value: model.resolvePrimaryKey(),
                        text: model.getFilterLabel(),
                    });
                });
                this.items = [...this.items, ...data]; // #KAK
            }
            else {
                this.items = [...this.items, ...models]; // #KAK
            }
            this.isLoading = false;
        });
    }
    appendIconCallback() {
        this.selected = [];
        this.items = [];
        this.search = '';
        this.$emit('iconCallBack');
    }
    setDefaultValue(item, fillSearch = true) {
        if (this.multiple) {
            this.$set(this, 'selected', isArray(item) ? item : [item]);
        }
        else {
            this.$set(this, 'selected', isArray(item) ? item[0] : item);
        }
        this.$set(this, 'items', isArray(item) ? item : [item]);
        if (fillSearch) {
            this.$set(this, 'search', isArray(item) ? item[0].text : item.text);
        }
    }
    removeSelected(item) {
        if (typeof item === 'object') {
            this.selected = this.selected.filter((selected) => !isEqual(selected, item));
            return;
        }
        this.selected = this.selected.filter((selected) => selected !== item);
    }
    selectedChanged(selected) {
        const data = [];
        if (this.multiple) {
            selected.forEach((currentSelected) => {
                const index = this.items.findIndex((item) => {
                    if (!currentSelected.value) {
                        return item.value === currentSelected;
                    }
                    return item.value === currentSelected.value;
                });
                data.push(this.items[index]);
            });
            if (!this.returnObject) {
                this.$emit('input', data.map((element) => {
                    return element.value;
                }));
            }
            else {
                this.$emit('input', data);
            }
        }
        else {
            if (typeof selected === 'string') {
                const index = this.items.findIndex((item) => item.value === selected);
                if (!this.returnObject) {
                    this.$emit('input', this.items[index].value);
                }
                else {
                    this.$emit('input', this.items[index]);
                }
            }
            else if (Array.isArray(selected)) {
                this.$emit('input', this.selected[0]);
            }
            else if (typeof selected === 'object' && selected.constructor === Object) {
                if (!this.returnObject) {
                    this.$emit('input', selected.value);
                }
                else {
                    this.$emit('input', selected);
                }
            }
        }
    }
    defaultChanged(defaultValue) {
        if (defaultValue) {
            this.setDefaultValue(defaultValue);
        }
    }
    clearSelect(clear) {
        if (clear) {
            this.$nextTick(() => {
                this.selected = [];
                this.search = '';
                this.$emit('cleared', true);
            });
        }
    }
};
__decorate([
    Prop({ default: () => { } }),
    __metadata("design:type", Object)
], AsyncSelect.prototype, "defaultValue", void 0);
__decorate([
    Prop({ default: () => new Model() }),
    __metadata("design:type", typeof (_a = typeof Model !== "undefined" && Model) === "function" ? _a : Object)
], AsyncSelect.prototype, "model", void 0);
__decorate([
    Prop({ default: () => { } }),
    __metadata("design:type", typeof (_b = typeof Object !== "undefined" && Object) === "function" ? _b : Object)
], AsyncSelect.prototype, "filters", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], AsyncSelect.prototype, "multiple", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], AsyncSelect.prototype, "clear", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", String)
], AsyncSelect.prototype, "label", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", String)
], AsyncSelect.prototype, "appendIcon", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", String)
], AsyncSelect.prototype, "placeholder", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], AsyncSelect.prototype, "required", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], AsyncSelect.prototype, "returnObject", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], AsyncSelect.prototype, "extraClass", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], AsyncSelect.prototype, "attach", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], AsyncSelect.prototype, "parseData", void 0);
__decorate([
    Prop({ default: 3 }),
    __metadata("design:type", Number)
], AsyncSelect.prototype, "minimumQueryLength", void 0);
__decorate([
    Watch('search'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], AsyncSelect.prototype, "searchChanged", null);
__decorate([
    Watch('selected'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AsyncSelect.prototype, "selectedChanged", null);
__decorate([
    Watch('defaultValue', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AsyncSelect.prototype, "defaultChanged", null);
__decorate([
    Watch('clear'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AsyncSelect.prototype, "clearSelect", null);
AsyncSelect = __decorate([
    Component({
        components: {
            PageHeader,
        },
    })
], AsyncSelect);
export default AsyncSelect;
